var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"container"},[_c('text',{staticClass:"title"},[_vm._v("复制内容")]),_c('text',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]),_c('view',{staticClass:"button",on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}},[_vm._v("一键复制")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }